import { IAssignee, IAssigneeIdMap, IAssigneesStoreState } from "@gtmhub/assignees";
import { GtmhubController } from "@gtmhub/core";
import { IGHGridColumn } from "@gtmhub/shared/components/grid/grid.component";
import { INgRedux } from "@gtmhub/state-management";
import { ITag } from "@gtmhub/tags/models";
import { isDuplicateTagTitleResponseError } from "@gtmhub/tags/utils";
import { IComponentOptions, IHttpResponse, IPromise } from "angular";
import { ITagsGridChangeAction, ITagsGridChangePayload } from "../tags-grid/tags-grid.component";

interface IAssigneesState {
  assignees: IAssigneeIdMap;
}

const bindStateToScope = (state: IAssigneesStoreState): IAssigneesState => ({
  assignees: state.assignees.map,
});

export interface ITagCellComponentBindings {
  item: ITag;
  column: IGHGridColumn;
  rowIndex: number;
  onChange?(payload: ITagsGridChangePayload): IPromise<void | unknown>;
  loading?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface TagCellCtrl extends ITagCellComponentBindings {}
export class TagCellCtrl extends GtmhubController implements IAssigneesState, ITagCellComponentBindings {
  static $inject = ["$ngRedux"];
  public tagData: Partial<ITag>;
  public assignees: IAssigneeIdMap;

  get assignee(): IAssignee {
    if (this.item?.createdBy) {
      return this.assignees[this.item.createdBy];
    }
    return null;
  }

  public constructor(private $ngRedux: INgRedux) {
    super();
    this.onDestroy(this.$ngRedux.connect(bindStateToScope)(this));
  }

  $onInit(): void {
    this.tagData = { title: this.item.title };
  }

  public executeAction(action: ITagsGridChangeAction): IPromise<void | unknown> {
    if (!this.onChange) {
      throw new Error("Missing onChange callback");
    }

    return this.onChange({ item: this.item, action, rowIndex: this.rowIndex });
  }

  public onTagTitleBlur(): void {
    this.rename();
  }

  public onTagTitleKeydown(e: KeyboardEvent): void {
    if (e.key !== "Escape" && e.key !== "Enter") {
      return;
    }

    if (e.key === "Escape") {
      this.tagData.title = this.item.title;
    } else if (e.key === "Enter") {
      this.rename();
    }

    (e.target as HTMLElement).blur();
  }

  private rename(): void {
    if (!this.tagData.title || this.tagData.title === this.item.title) {
      return;
    }

    const originalTitle = this.item.title;
    this.item.title = this.tagData.title;
    this.executeAction("rename").then((result) => {
      if (isDuplicateTagTitleResponseError(result as IHttpResponse<unknown>)) {
        this.tagData.title = originalTitle;
        this.item.title = originalTitle;
      }
    });
  }
}

export const TagCellCompoent: IComponentOptions = {
  bindings: {
    item: "<",
    column: "<",
    rowIndex: "<",
    onChange: "&",
    loading: "<",
  },
  controller: TagCellCtrl,
  templateUrl: require("./tag-cell.component.html"),
  transclude: true,
};
